import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
} from '@angular/core';
import { AddressBaseUi } from '../../models/address.model';
import { MatIconButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';

export enum CopyButtonMode {
  Off = 'off',
  OnHover = 'on-hover',
  OnAlways = 'on-always',
}

@Component({
  selector: 'ri-resolution-ui-mailing-address',
  imports: [MatIconButton, MatIcon],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './mailing-address.component.html',
})
export class MailingAddressComponent {
  readonly address = input<AddressBaseUi>();
  readonly copyButtonMode = input<CopyButtonMode>(CopyButtonMode.OnHover);

  enableCopyButton = computed(() => {
    const copyButtonMode = this.copyButtonMode();
    return (
      copyButtonMode === CopyButtonMode.OnAlways ||
      copyButtonMode === CopyButtonMode.OnHover
    );
  });

  onHover = computed(() => {
    return this.copyButtonMode() === CopyButtonMode.OnHover;
  });

  copyToClipboard() {
    const address = this.address();

    if (!address) {
      return;
    }

    const formattedAddress = [
      address?.addressee ? address.addressee : '',
      address?.attention ? `Attn: ${address.attention}` : '',
      address?.address1,
      address?.address2 ? address.address2 : '',
      `${address?.city}, ${address?.state} ${address?.zipCode}`,
    ]
      .filter((line) => line?.trim() !== '')
      .join('\n');

    navigator.clipboard.writeText(formattedAddress);
  }
}
